export const linesStyles = {
  display: 'flex',
  flexDirection: 'column',
  gap: '4px',
  minWidth: 0,
};

export const lineStyles = {
  display: 'flex',
  flexDirection: 'column',
  gap: '2px',
  minWidth: 0,
};

export const valueStyles = {
  wordBreak: 'break-word',
};

// Template text is prose, so the old side is struck through in the body font, not the module's
// monospace field-value style.
export const beforeValueStyles = {
  ...valueStyles,
  color: ({ palette }) => palette.text.secondary,
  textDecoration: 'line-through',
};
